module.exports = "<div class=\"wd-skeleton wd-skeleton-form\">\n    <div class=\"rect\" style=\"height: 100%;\"></div>\n    form\n</div>";